module.exports = __webpack_public_path__ + "static/img/xueshu5.b697785b.webp";